import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import TaskActions from 'store/task/action'
import { ITask } from 'types/models'

import Loader from 'components/Loader'
import Task from '../../Task'
import { NoTask } from '../../NoTask'

type Props = {
  highPrioriy: {
    count: number
    rows: ITask[]
  }
  isLoading: boolean
  deleteTask: any
  closeTask: any
}

export const HighTasks = React.memo<Props>(({ highPrioriy, isLoading, deleteTask, closeTask }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(TaskActions.getTaskListByFilter('high'))
  }, [dispatch])

  const renderHigh = () => (
    <>
      {highPrioriy.rows && highPrioriy.rows.length ? (
        highPrioriy.rows.map(el => {
          return (
            <Task
              id={el.id}
              key={el.id}
              title={el.title}
              type="high"
              description={el.description}
              dueDate={el.dueDate}
              dueTime={el.dueTime}
              deleteTask={deleteTask}
              closeTask={closeTask}
              priority="high priority"
            />
          )
        })
      ) : (
        <NoTask />
      )}
    </>
  )

  return <>{isLoading ? <Loader height="400px" /> : renderHigh()}</>
})
